import { Identifiable, Project, TimeSheetFilter } from "@planzone/dto";
import { State } from "./types";

function areFiltersMatching(a: TimeSheetFilter, b: TimeSheetFilter) {
  return a.minDate === b.minDate && a.maxDate === b.maxDate;
}

function matchRequest(req: State[number], filter: TimeSheetFilter): boolean {
  return areFiltersMatching(req.filter, filter);
}

export { matchRequest };
